// @ts-check
/**
 * @file memberView.js
 * @location src/utils/memberView.js
 * @role 팀원 업무탭 화면 파생 — 업무도착(inbox)/표(table)/오늘·예정 카운트 분리.
 *   미- 예정(ondate, due>today)은 숨기지 않고 예정업무 섹션으로(미리 열람 가능).
 *   업무도착 = 오늘 도래분 안 읽음만, 예정는 읽음여부 무관 표(yotei)로.
 */
import { isClosed } from '../data/labels.js';
import { activeOrClosedToday } from './taskSelectors.js';

/**
 * @param {import('../data/types.js').Task[]} allVisible  가시성 필터된 본인 task
 * @param {{ unack: any[], overdue: any[], future: any[] }} buckets  getAttentionBuckets 결과
 * @param {string} today YYYY-MM-DD
 * @returns {{ inboxUnread: any[], tableTasks: any[], todayCount: number, futureCount: number }}
 *   todayCount = inbox + table 합산(미완·비예정 전체, 오늘 처리 대상). 예정·완료 제외.
 */
export function deriveMemberView(allVisible, buckets, today) {
  const futureIds = new Set(buckets.future.map(t => t.id));
  // 업무도착 = 안 읽음 중 미래 예정 제외(예정은 표로 미리 surfacing)
  const inboxUnread = buckets.unack.filter(t => !futureIds.has(t.id));
  // 표 = 오늘 도래분 중 (미래 예정 OR 읽음 OR 종결). 안 읽음 비예정은 우체통으로 빠짐.
  const tableTasks = activeOrClosedToday(allVisible, today)
    .filter(t => futureIds.has(t.id) || t.acknowledgedAt || isClosed(t.status));
  // 오늘 카운트 = 미완·비예정 (오늘 처리 대상). 예정·완료 제외.
  const todayCount = allVisible.filter(t => !isClosed(t.status) && !futureIds.has(t.id)).length;
  return { inboxUnread, tableTasks, todayCount, futureCount: buckets.future.length };
}
